import {
    GET_STATUSES_REQUEST,
    GET_STATUSES_SUCCESS,
    GET_STATUSES_FAILURE,
    GET_TRANSITIONS_REQUEST,
    GET_TRANSITIONS_SUCCESS,
    GET_TRANSITIONS_FAILURE,
    SET_STATUSES,
    SET_TANSITIONS
} from '../actions/statuses';
import { buildStatuses, buildTransitions } from '../helpers/statuses';
const initialState = {
    statuses: [],
    transitions: [],
    fetching: false,
    type: "installations"
};

export default (state = initialState, action) => {
    switch (action.type) {
        case GET_STATUSES_REQUEST: {
            return {
                ...state,
                fetching: true
            };
        }
        case GET_STATUSES_SUCCESS: {

            return {
                ...state,
                fetching: false,
                statuses: buildStatuses(action.payload.statuses, action.payload.type),
                type: action.payload.type
            };
        }
        case GET_STATUSES_FAILURE: {
            return {
                ...state,
                fetching: false
            };
        }
        case GET_TRANSITIONS_REQUEST: {
            return {
                ...state,
                fetching: true,
                transitions: []
            };
        }
        case GET_TRANSITIONS_SUCCESS: {
            return {
                ...state,
                fetching: false,
                transitions: buildTransitions(action.payload.transitions, action.payload.type)
            };
        }
        case GET_TRANSITIONS_FAILURE: {
            return {
                ...state,
                fetching: false
            };
        }
        case SET_STATUSES: {
            return {
                ...state,
                statuses: action.payload.statuses
            };
        }
        case SET_TANSITIONS: {
            return {
                ...state,
                transitions: action.payload.transitions
            };
        }
        default:
            return state;
    }
};
